var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpChatDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 2.91406C9.45008 2.91406 2.91675 9.4474 2.91675 17.4974C2.91675 25.5474 9.45008 32.0807 17.5001 32.0807C25.5501 32.0807 32.0834 25.5474 32.0834 17.4974C32.0834 9.4474 25.5501 2.91406 17.5001 2.91406ZM22.648 17.5411C22.4292 17.7599 22.1522 17.862 21.8751 17.862C21.598 17.862 21.3209 17.7599 21.1022 17.5411L18.5938 15.0328V22.6016C18.5938 23.1995 18.098 23.6953 17.5001 23.6953C16.9022 23.6953 16.4063 23.1995 16.4063 22.6016V15.0328L13.898 17.5411C13.4751 17.9641 12.7751 17.9641 12.3522 17.5411C11.9292 17.1182 11.9292 16.4182 12.3522 15.9953L16.7272 11.6203C17.1501 11.1974 17.8501 11.1974 18.273 11.6203L22.648 15.9953C23.0709 16.4182 23.0709 17.1182 22.648 17.5411Z",
    fill: "#FB4764",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpChatDisabled);
export default __webpack_public_path__ + "static/media/arrow-up-chat-disabled.e17f6e07896636a1e5a5c30e4b203a6f.svg";
export { ForwardRef as ReactComponent };